import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { PlayerModel, DataListResponse } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {
  private apiUrl = '/api/players';

  constructor(private http: HttpClient) { }

  getAll(page: number = 1, pageSize: number = 10, search?: string, sortField?: string, sortOrder?: number): Observable<DataListResponse<PlayerModel>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) params = params.set('search', search);
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder) params = params.set('sortOrder', sortOrder.toString());

    return this.http.get<DataListResponse<PlayerModel>>(`${this.apiUrl}/all`, { params });
  }

  getAllSimple(): Observable<PlayerModel[]> {
    return this.getAll(1, 10).pipe(
      map(res => res.data)
    );
  }

  searchPlayers(query: string): Observable<PlayerModel[]> {
    return this.http.get<PlayerModel[]>(`${this.apiUrl}/search`, { params: { query } });
  }

  getById(id: number): Observable<PlayerModel> {
    return this.http.get<PlayerModel>(`${this.apiUrl}/${id}`);
  }

  post(player: PlayerModel): Observable<PlayerModel> {
    return this.http.post<PlayerModel>(this.apiUrl, player);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
